module.exports = __webpack_public_path__ + "img/fopeaVacaMuerta2a.b4f4cff8.jpg";